import type { Format, FormatScoreInput, RoundResult } from "./types.js";
import {
  allowanceNote,
  bestTeamNetOnHole,
  buildScoreMap,
  computeHandicaps,
  describeSegmentPoints,
  holeCount,
  holeNumbersInPlay,
  scoreSegmentsByTotal,
} from "./util.js";

/** Scores just as four-ball once each player finishes the hole with their own ball
 * (the shared best-drive rule doesn't change the scoring math). */
function betterBall({ round, course, players, scores }: FormatScoreInput) {
  const scoreMap = buildScoreMap(scores);
  const handicaps = computeHandicaps(round, course, players);
  return (team: string[], hole: number) => bestTeamNetOnHole(scoreMap, handicaps, team, hole);
}

export const shamble: Format = {
  id: "shamble",
  name: "Shamble",
  scope: "team",
  uses: { teamPoints: true, handicapAllowance: true },
  entry: "perPlayer",
  defaults: { handicapAllowance: 90 },
  configSchema: { type: "object", properties: {} },
  perHoleSchema: null,

  score(input): RoundResult {
    const { round, course, players, onlyHoles } = input;
    return scoreSegmentsByTotal(
      round,
      players,
      holeNumbersInPlay(round, course),
      betterBall(input),
      onlyHoles,
    );
  },

  sideValueOnHole: betterBall,

  describeRules(round, _players, course) {
    return [
      `Shamble across ${holeCount(round, course)} holes: the team plays the best drive, then each player plays their own ball in. The team's score on a hole is the better of its two players' net scores.`,
      describeSegmentPoints(round),
      `Handicap allowance: ${round.handicapAllowance}%${allowanceNote(round, course)}.`,
    ];
  },
};
